import { createContext, useContext } from "react";

export const SnackbarContext = createContext({ showSnackbar: undefined });

/**
 * スナックバーコンテキスト
 * @class useSnackbarContext
 */
export function useSnackbarContext() {
  return useContext(SnackbarContext);
}
